import { Flex, Text } from '@chakra-ui/react'
import { Icon } from '@ubirider/pick-component-library'
import { useContext } from 'react'
import { useTranslation } from 'react-i18next'
import { AuthContext } from '../../../../AuthProvider'
import AcquaViasLogo from '../../../../assets/logo.svg'

export const TopBar = props => {
  const { t } = useTranslation()
  const Auth = useContext(AuthContext)
  const user = Auth.user

  return (
    <>
      <Flex display={{ sm: 'none', md: 'flex', lg: 'flex', xl: 'flex' }} justifyContent='space-between'>
        <Icon src={AcquaViasLogo} css={{ width: 139, height: 40 }} />
        <Flex gap='18px'>
          <Flex align='center' gap='18px'>
            <Text>
              {t('home.welcome')} {props.name ? props.name.split(' ')[0] : user.email}
            </Text>
          </Flex>
        </Flex>
      </Flex>
    </>
  )
}
